"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _two = _interopRequireDefault(require("@/components/upload/two"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    upload: _two.default
  },
  data: function data() {
    return {
      aid: this.$route.query.aid || '',
      form: {}
    };
  },
  computed: {},
  mounted: function mounted() {
    this.getInfo();
  },
  methods: {
    getInfo: function getInfo() {
      var _this = this;
      this.$get('agentapi/sttuf/my_son_detail', {
        son_id: this.aid
      }).then(function (res) {
        _this.form = res;
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      var params = this.form;
      params.son_id = this.aid;
      this.$post('agentapi/apply/modify_son_account_fileds', this.form).then(function (res) {
        _this2.$message({
          message: '修改成功',
          type: 'success'
        });
        history.go(-1);
      });
    }
  }
};